import { render, staticRenderFns } from "./TooltipButton.vue?vue&type=template&id=25f98e54&"
import script from "./TooltipButton.vue?vue&type=script&lang=js&"
export * from "./TooltipButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports